import http from '@/libs/AxiosPlugin'

const monitor = {
  collectors () {
    return http.get('/collectorMonitor/list')
  },
  producting (id) {
    return http.post('/board/getProducting', id)
  },
  orders () {
    return http.get('/orderMonitor/list')
  }
}

export default monitor



// WEBPACK FOOTER //
// ./src/api/monitor.js